export enum DateGroup {
  TODAY = 1,
  FIFTEEN_DAYS = 2,
  THIRTY_DAYS = 3,
}
